import React, { useState, useEffect } from "react";
import axios from "axios";
import { Url } from "../config/config";
import { toast } from "react-toastify";
import useFullPageLoader from "../hooks/useFullPageLoader";

export default function Dashboard() {
  //************************Dashboard Count With Filter */
  const [dashboard, updateDashboard] = useState({});
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [inputField, setInputField] = useState({
    from_date: "",
    to_date: "",
  });
  const handelDashboardData = async (from_date = "", to_date = "") => {
    console.log(from_date);
    try {
      showLoader();
      const res = await axios({
        url: `${Url}/deshboard?from_date=${from_date}&to_date=${to_date}`,
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      hideLoader();
      console.log("dashboard", res.data.data);
      updateDashboard(res.data.data);
      console.log(res.data.data);
    } catch (err) {
      console.log(err);
      toast.error("Something wents wrong, please try again");
    }
  };
  //**************Handel Input change *********/
  const handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputField({
      ...inputField,
      [name]: value,
    });
  };

  //******************Handel Search Filter*********** */
  const handelSearchFilter = () => {
    //console.log(inputField);
    handelDashboardData(inputField.from_date, inputField.to_date);
  };

  useEffect(() => {
    handelDashboardData();
  }, []);
  return (
    <React.Fragment>
      <title>Volt | Dashboard</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <h4 className="Title">Dashboard</h4>

            <div className="DashboardArea">
              <div className="DashboardFilter">
                <div className="Date">
                  <input
                    type="date"
                    name="from_date"
                    value={inputField.from_date}
                    onChange={handleInputChange}
                  />
                  <input
                    type="date"
                    name="to_date"
                    value={inputField.to_date}
                    onChange={handleInputChange}
                  />
                  <button onClick={handelSearchFilter}>Submit</button>
                </div>

                {/* <select>
                  <option>Sort By</option>
                  <option>Today</option>
                  <option>This Week</option>
                  <option>This Month</option>
                  <option>This Year</option>
                </select> */}

                <div className="clear"></div>
              </div>

              <div className="row">
                {loader}
                <div className="col-sm-4">
                  <aside>
                    <h4>Total Requests</h4>
                    <h2 className="Green">{dashboard.totalUsers}</h2>
                    {/* <h5>
                      <span>Total Requests :</span> 25
                    </h5> */}
                  </aside>
                </div>
                <div className="col-sm-4">
                  <aside>
                    <h4>Total Eligible</h4>
                    <h2 className="Blue">{dashboard.totalEligible}</h2>
                    {/* <h5>
                      <span>Total Accepted Requests :</span> 35
                    </h5> */}
                  </aside>
                </div>
                <div className="col-sm-4">
                  <aside>
                    <h4>Solar Requests</h4>
                    <h2 className="Red">{dashboard.totalSolarRequest}</h2>
                    {/* <h5>
                      <span>Total Rejected Requests :</span> 125
                    </h5> */}
                  </aside>
                </div>

                <div className="col-sm-4">
                  <aside>
                    <h4>Solar Request Shared with Partners</h4>
                    <h2 className="Red">
                      {dashboard.totalSolarReqSendPartner}
                    </h2>
                    {/* <h5>
                      <span>Total Queries :</span> 125
                    </h5> */}
                  </aside>
                </div>

                <div className="col-sm-4">
                  <aside>
                    <h4>Approval from Financial Partner</h4>
                    <h2 className="Green">
                      {dashboard.totalRequestApprovedByPartner}
                    </h2>
                    {/* <h5>
                      <span>Total Financial Partner :</span> 125
                    </h5> */}
                  </aside>
                </div>

                <div className="col-sm-4">
                  <aside>
                    <h4>Total lead by marketing partner</h4>
                    <h2 className="Blue">
                      {dashboard?.totalLeadByMarketingPartner}
                    </h2>
                  </aside>
                </div>

                <div className="col-sm-4">
                  <aside>
                    <h4>Total marketing partner</h4>
                    <h2 className="Green">
                      {dashboard?.totalMarketingPartner}
                    </h2>
                  </aside>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
